import { trackEvent } from '@patrianna/analytics'
import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'
import { nextTick } from '@patrianna/shared-utils'
import { InformationOutline } from '@patrianna-icons/material-icons'
import Link from 'next/link'
import type { MouseEvent } from 'react'

import type { SupportedCurrencies } from 'types/currencies'
import { hasTag } from 'utils/gameTags'
import { getSlotStartUrlByGameType } from 'utils/navigator/games'

import classes from './styles.module.scss'

type Props = {
  game: GameProductShort
  activeCurrency: SupportedCurrencies
  className?: string
}

function MoreInfoBtn(props: Props) {
  const isTableGame = hasTag(props.game.tags, 'table')
  const isSlingoGame = hasTag(props.game.tags, 'SLI')
  // ToDo needs to add 'in_house' tag to @Patrianna TagsType
  // @ts-ignore
  const isArcadeGame = hasTag(props.game.tags, 'in_house')
  const url = `/${getSlotStartUrlByGameType(isTableGame, isSlingoGame, isArcadeGame)}/${props.game.route}/${
    props.activeCurrency === 'SC' ? 'sweepstake' : ''
  }`

  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.stopPropagation()

    nextTick().then(() => {
      trackEvent('game_tile_i_icon_click')
    })
  }

  return (
    <div className={classes.moreInfoBtn}>
      <Link
        href={url}
        prefetch={false}
        className={classes.moreInfoBtnIcon}
        onClick={onClick}
        title={props.game.title}
        aria-label={`More information about ${props.game.title}`}
      >
        <InformationOutline />
      </Link>
    </div>
  )
}

export default MoreInfoBtn
